var _rect, _path, _path2, _path3, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSinkhole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 4.83333,
    stroke: "#33BCB7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 6.66669C10.8452 6.66669 6.66602 10.8459 6.66602 16C6.66602 21.1542 10.8452 25.3334 15.9993 25.3334C21.1535 25.3334 25.3327 21.1542 25.3327 16C25.3327 10.8459 21.1535 6.66669 15.9993 6.66669ZM15.9993 23.75C11.7202 23.75 8.24935 20.2792 8.24935 16C8.24935 11.7209 11.7202 8.25002 15.9993 8.25002C20.2785 8.25002 23.7493 11.7209 23.7493 16C23.7493 20.2792 20.2785 23.75 15.9993 23.75Z",
    fill: "#33BCB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 9.7778C12.5635 9.7778 9.77734 12.5639 9.77734 16C9.77734 19.4361 12.5635 22.2222 15.9996 22.2222C19.4357 22.2222 22.2218 19.4361 22.2218 16C22.2218 12.5639 19.4357 9.7778 15.9996 9.7778ZM15.9996 21.1667C13.1468 21.1667 10.8329 18.8528 10.8329 16C10.8329 13.1472 13.1468 10.8334 15.9996 10.8334C18.8523 10.8334 21.1662 13.1472 21.1662 16C21.1662 18.8528 18.8523 21.1667 15.9996 21.1667Z",
    fill: "#33BCB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9989 12.4444C14.0354 12.4444 12.4434 14.0365 12.4434 16C12.4434 17.9635 14.0354 19.5556 15.9989 19.5556C17.9624 19.5556 19.5545 17.9635 19.5545 16C19.5545 14.0365 17.9624 12.4444 15.9989 12.4444ZM15.9989 18.9524C14.3688 18.9524 13.0465 17.6302 13.0465 16C13.0465 14.3698 14.3688 13.0476 15.9989 13.0476C17.6291 13.0476 18.9513 14.3698 18.9513 16C18.9513 17.6302 17.6291 18.9524 15.9989 18.9524Z",
    fill: "#33BCB7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.0004,
    cy: 16,
    r: 1.77778,
    fill: "#33BCB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinkhole);
export default __webpack_public_path__ + "static/media/sinkhole.89ed2f5ebf795c61267f76179195db11.svg";
export { ForwardRef as ReactComponent };